module.exports = __webpack_public_path__ + "static/media/imaging_Syllabus.020e92de.pdf";